import React, { Component } from 'react';
import { batch, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate } from 'datesHelper.js';
import Loader from 'Loader.js';
import S from 'StyledAccountHistoryBonus.js';
import Pagination from 'Pagination.js';
import {
  setCurrentPage,
  fetchCreditBonusListByFilter,
  fetchCreditBonusListPending,
  fetchCreditBonusListFulfilled,
  fetchCreditBonusListFailure,
} from 'accountBonusActions.js';
import { proccessFrontError } from 'errorActions.js';

class AccountHistoricalBonus extends Component {
  componentDidMount = async () => {
    const { fetchCreditBonusListByFilter, processFrontError } = this.props;
    try {
      await fetchCreditBonusListByFilter({ activeTab: 'history' });
    } catch (error) {
      processFrontError(error, 'AccountHistoricalBonus.componentDidMount');
    }
  };

  goPage = (currentPage) => {
    const { fetchCreditBonusListByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchCreditBonusListByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountHistoricalBonus.goPage');
    }
  };

  render() {
    const { isPending, bonus, currencyCode, limit } = this.props;
    const { data, currentPage, isNextPageAvailable } = bonus.history;

    return (
      <S.AccountHistoryBonus className="account-history-bonus">
        {isPending ? (
          <Loader />
        ) : (
          <>
            <S.BonusListWrapper>
              {data.length > 0 ? (
                <>
                  <S.BonusList>
                    {data.map((bonus) => {
                      const {
                        offerId,
                        nameKey,
                        assignedBonusAmount,
                        validTo,
                        activationTime,
                        offerPlayerInfo = {},
                      } = bonus;
                      const { imageUrl, rulesPageUrl } = offerPlayerInfo;
                      const bonusItem = (
                        <S.BonusItem key={offerId}>
                          <S.BonusHeader>
                            <S.BonusTitle data-translation={nameKey}>
                              {translation(nameKey)}
                            </S.BonusTitle>
                          </S.BonusHeader>

                          <S.BonusImageWrapper ratio={2}>
                            {imageUrl && <S.BonusImage src={`${imageUrl}`} />}
                          </S.BonusImageWrapper>

                          <S.BonusBody>
                            <S.BonusBox>
                              <S.BonusBoxTitle>
                                {translation('account_bonus_activationTime')}
                              </S.BonusBoxTitle>
                              <S.BonusBoxValue>
                                {formatDate(activationTime, 'yyyy-MM-dd HH:mm')}
                              </S.BonusBoxValue>
                            </S.BonusBox>

                            <S.BonusBox>
                              <S.BonusBoxTitle>
                                {translation('account_bonus_amount')}
                              </S.BonusBoxTitle>
                              <S.BonusBoxValue>
                                {formatMoney(assignedBonusAmount)}&nbsp;{currencyCode}
                              </S.BonusBoxValue>
                            </S.BonusBox>

                            <S.BonusBox>
                              <S.BonusBoxTitle>
                                {translation('account_bonus_validToDate')}
                              </S.BonusBoxTitle>
                              <S.BonusBoxValue>
                                {formatDate(validTo, 'yyyy-MM-dd HH:mm')}
                              </S.BonusBoxValue>
                            </S.BonusBox>
                          </S.BonusBody>

                          <S.BonusFooter>
                            <S.BonusRegulationLink
                              href={rulesPageUrl ? rulesPageUrl : '/'}
                              target="_blank"
                            >
                              {translation('account_bonus_regulationLink')}
                            </S.BonusRegulationLink>
                          </S.BonusFooter>
                        </S.BonusItem>
                      );
                      return bonusItem;
                    })}
                  </S.BonusList>

                  <Pagination
                    {...{
                      currentPage,
                      limit,
                      data,
                      callback: this.goPage,
                      isNextPageAvailable,
                    }}
                  />
                </>
              ) : (
                <S.NoResult>{translation('account_bonus_notFound')}</S.NoResult>
              )}
            </S.BonusListWrapper>
          </>
        )}
      </S.AccountHistoryBonus>
    );
  }
}

const mapStateToProps = ({
  AccountBonus: { isPending, error, startDate, endDate, activeTab, limit, bonus },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    bonus,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchCreditBonusListByFilter: bindActionCreators(fetchCreditBonusListByFilter, dispatch),
    fetchCreditBonusListPending: bindActionCreators(fetchCreditBonusListPending, dispatch),
    fetchCreditBonusListFulfilled: bindActionCreators(fetchCreditBonusListFulfilled, dispatch),
    fetchCreditBonusListFailure: bindActionCreators(fetchCreditBonusListFailure, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountHistoricalBonus);
